/* Bear Baby Boutique – sticky add-to-cart (mobiel).
   Toont de balk zodra de primaire knop uit beeld is gescrold en houdt prijs, variant en
   knopstatus gelijk met de hoofdform via Dawn's variantChange-event. */
(() => {
  const initBar = (bar) => {
    if (bar.dataset.bbInit) return;
    bar.dataset.bbInit = 'true';

    const sectionId = bar.dataset.sectionId;
    const getSubmit = () => document.getElementById(`ProductSubmitButton-${sectionId}`);
    const submit = getSubmit();
    if (!submit) return;

    const bindButton = () => {
      const button = bar.querySelector('.bb-sticky-atc__button');
      if (!button) return;
      button.addEventListener('click', () => {
        const target = getSubmit();
        if (target && !target.disabled) target.click();
      });
    };
    bindButton();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.hidden = !scrolledPast;
          bar.classList.toggle('is-visible', scrolledPast);
          document.body.classList.toggle('bb-sticky-atc-visible', scrolledPast);
        });
      },
      { threshold: 0 }
    );
    observer.observe(submit);

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const data = event && event.data;
        if (!data || data.sectionId !== sectionId || !data.html) return;
        const fresh = data.html.getElementById(bar.id);
        const freshInner = fresh && fresh.querySelector('.bb-sticky-atc__inner');
        const inner = bar.querySelector('.bb-sticky-atc__inner');
        if (!freshInner || !inner) return;
        inner.innerHTML = freshInner.innerHTML;
        bindButton();
      });
    }
  };

  const start = () => document.querySelectorAll('.bb-sticky-atc').forEach(initBar);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
